import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { Screen } from '@confluence/screen';
import { MainLayout } from '@confluence/main-layout';
import { useBooleanFeatureFlag } from '@confluence/session-data';
import { ADMIN_MIGRATION_SPACE_SETTINGS_FF } from '@confluence/site-settings';
import {
	SPACE_SETTINGS_THEMES_LEGACY,
	SPACE_SETTINGS_TEMPLATES_LEGACY,
	SPACE_SETTINGS_HEADER_AND_FOOTER_LEGACY,
	SPACE_SETTINGS_PDF_EXPORT_LEGACY,
} from '@confluence/named-routes';
import type { Match } from '@confluence/route-manager';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

const SpaceLookAndFeelSettingsRouteComponent = LoadablePaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceLookAndFeelSettingsRouteComponent" */ './SpaceLookAndFeelSettingsRouteComponent'
		),
});

const getLegacyPageURL = (tab: string) => {
	switch (tab) {
		default:
		case 'themes':
			return SPACE_SETTINGS_THEMES_LEGACY.name;
		case 'templates':
			return SPACE_SETTINGS_TEMPLATES_LEGACY.name;
		case 'header-and-footer':
			return SPACE_SETTINGS_HEADER_AND_FOOTER_LEGACY.name;
		case 'pdf-export':
			return SPACE_SETTINGS_PDF_EXPORT_LEGACY.name;
	}
};

export const SpaceLookAndFeelSettingsRoute: React.FC<Match> = ({
	name,
	params: { spaceKey, tab },
}) => {
	const isSPAPageEnabled = useBooleanFeatureFlag(ADMIN_MIGRATION_SPACE_SETTINGS_FF);

	if (!isSPAPageEnabled) {
		return <Redirection name={getLegacyPageURL(tab)} params={{ spaceKey }} />;
	}

	return (
		<Screen
			screenEvent={{
				name: 'spaceSettingLookAndFeelPage',
				id: spaceKey,
			}}
			pageState={{
				routeName: name,
				spaceKey: spaceKey,
			}}
		>
			<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
				<SpaceLookAndFeelSettingsRouteComponent spaceKey={spaceKey} tab={tab} />
			</MainLayout>
		</Screen>
	);
};
